import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { hotArticles } from '@/mocks/homeData';

export default function HotGridSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider mb-1">
                热门追踪
              </p>
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 italic">
                最新黑料爆料
              </h2>
            </div>
            <div className="max-w-md">
              <p className="text-sm text-foreground-600 leading-relaxed">
                实时追踪最新爆出的网红黑料与明星塌房事件，每一条都经过严格核实，让你吃得放心，看得过瘾。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {hotArticles.map((article, index) => (
              <ArticleCard
                key={article.id}
                title={article.title}
                category={article.category}
                categorySlug={article.categorySlug}
                date={article.date}
                image={article.image}
                slug={article.slug}
                variant={index === 1 ? 'accent' : 'default'}
              />
            ))}
          </div>

          <div className="flex justify-center mt-10">
            <Link
              to="/category/all"
              className="px-8 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多爆料
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}